/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import {
  LabelledDetail,
  Grid,
  Spinner,
  Warning,
  SpanWithData
} from '../'

const QUERY_IDENTITY_BANKACCOUNTS = gql`
  query getIdentityBankAccounts($id: ID!) {
    identity(id: $id) {
      id
      bankaccounts {
        edges {
          node {
            id
            bankName
            accountNumber
            accountType
            beneficiaryName
            default
          }
        }
      }
    }
  }
`

export class IdentityBankAccountCardSmall extends React.PureComponent {
  static propTypes = {
    identity: PropTypes.string.isRequired,
    bankAccount: PropTypes.string,
    className: PropTypes.string
  }

  getBankAccount = (bankAccounts) => {
    if (this.props.bankAccount) {
      // check if this.props.bankAccount exists for identity
      let bankAccountOnIdentity = bankAccounts.find(bankAccount => (
        bankAccount.node.id === this.props.bankAccount
      ))
      if (bankAccountOnIdentity) {
        return bankAccountOnIdentity.node
      } else {
        return null
      }
    } else {
      let primaryBankAccount = bankAccounts.find(bankAccount => (
        bankAccount.node.default === true
      ))
      if (primaryBankAccount) {
        return primaryBankAccount.node
      } else {
        return null
      }
    }
  }

  render() {
    return (
      <Query query={QUERY_IDENTITY_BANKACCOUNTS} variables={{ id: this.props.identity }}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div className={`slds-grid slds-m-bottom_large ${this.props.className ? this.props.className : ''}`}>
                <Spinner className='slds-m-left_medium slds-is-relative slds-p-bottom_x-large' size='small' />
                <div className='slds-m-left_large'>Loading identity bank account data</div>
              </div>
            )
          }

          if (error) {
            return (
              <Warning className={`slds-m-bottom_large ${this.props.className ? this.props.className : ''}`}>
                Failed to load identity bank account data.
              </Warning>
            )
          }

          let bankAccount = data.identity.bankaccounts.edges.length > 0
            ? this.getBankAccount(data.identity.bankaccounts.edges)
            : null

          if (bankAccount) {
            return (
              <div className={this.props.className ? this.props.className : ''}>
                <div className='slds-m-top_large slds-m-bottom_medium'>
                  <div className='u-font-size-large u-font-weight-bold'>
                    Bank account
                  </div>
                  <div className='u-font-size-larger slds-text-color_weak'>
                    {`${bankAccount.bankName} `}
                    <SpanWithData forField='BankAccountAccountType' searchKey={bankAccount.accountType} />
                    {` account`}
                  </div>
                </div>
                <Grid
                  items={[
                    <LabelledDetail
                      label='Account number'
                      detail={bankAccount.accountNumber}
                      className='slds-m-bottom_small'
                    />,
                    <LabelledDetail
                      label='Beneficiary name'
                      detail={bankAccount.beneficiaryName}
                      className='slds-m-bottom_small'
                    />
                  ]}
                  className='slds-m-bottom_large'
                />
              </div>
            )
          } else {
            return null
          }
        }}
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/identity-bankaccount-card-small/index.js